var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cf-container" },
    [
      _vm.hasOverrideDays
        ? _c(
            "md-table",
            { staticClass: "override-day-table" },
            [
              _c(
                "md-table-row",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("md-table-head", [_vm._v("Name")]),
                  _c("md-table-head", [_vm._v("Override Date")]),
                  _c("md-table-head", [_vm._v("Actions")]),
                ],
                1
              ),
              _vm._l(_vm.filteredOverrideDays, function (overrideDay, index) {
                return _c(
                  "md-table-row",
                  { key: index },
                  [
                    _c(
                      "md-table-cell",
                      { staticClass: "override-day-name-column" },
                      [
                        _c(
                          "form-group",
                          [
                            _c("md-input", {
                              attrs: {
                                type: "text",
                                placeholder: "Eg. Valentine's Day",
                              },
                              model: {
                                value: overrideDay.overrideDayName,
                                callback: function ($$v) {
                                  _vm.$set(overrideDay, "overrideDayName", $$v)
                                },
                                expression: "overrideDay.overrideDayName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      { staticClass: "override-date-columns" },
                      [
                        _c("md-datepicker", {
                          attrs: {
                            "md-immediately": "",
                            "md-debounce": 100,
                            "md-model-type": String,
                          },
                          model: {
                            value: overrideDay.overrideDate,
                            callback: function ($$v) {
                              _vm.$set(overrideDay, "overrideDate", $$v)
                            },
                            expression: "overrideDay.overrideDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "md-table-cell",
                      { staticClass: "action-buttons-column" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-warning md-just-icon md-round",
                            attrs: { title: "Edit override day" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditOverrideDay(overrideDay)
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("edit")])],
                          1
                        ),
                        _c(
                          "md-button",
                          {
                            staticClass: "md-danger md-just-icon md-round",
                            attrs: { title: "Delete override day" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDeleteOverrideDay(overrideDay)
                              },
                            },
                          },
                          [_c("md-icon", [_vm._v("delete")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      !_vm.hasOverrideDays
        ? _c("div", { staticClass: "text-center" }, [
            _c("p", { staticClass: "no-result-message" }, [
              _vm._v("List is empty."),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "md-button",
            {
              staticClass:
                "md-button md-primary custom-add-override-day-button",
              on: { click: _vm.handleAddOverrideDay },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v("\n            Add Override Days\n        "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }